<template>
  <el-dialog
          :title="'设置尺寸'"
          :close-on-click-modal="false"
          :visible.sync="visible"
  style="text-align: left">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
             label-width="150px">
      <el-form-item label="春秋装尺寸" prop="uniformsaSize">
        <el-input clearable v-model="dataForm.uniformsaSize" ></el-input>
      </el-form-item>
      <el-form-item label="夏装尺寸" prop="uniformsSize">
        <el-input clearable v-model="dataForm.uniformsSize" ></el-input>
      </el-form-item>
      <el-form-item label="冬装尺寸" prop="uniformwSize">
        <el-input clearable v-model="dataForm.uniformwSize" ></el-input>
      </el-form-item>
      <el-form-item label="鞋子尺寸" prop="shoseSize">
        <el-input clearable v-model="dataForm.shoseSize" ></el-input>
      </el-form-item>
      <el-form-item label="帽子尺寸" prop="hatSize">
        <el-input clearable v-model="dataForm.hatSize" ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {

    data () {
      const validateNumber = (rule, value, callback) => {
        var patrn = /^\d+(\.\d+)?$/;
        if (!patrn.exec(value)) {
          callback(new Error('请填写数字'))
        } else {
          callback()
        }
      }
      return {
        form: {
          name:''

        },
        equips:[],
        loading:false,
        visible: false,
        useridList:[],
        menuList: [],
        customerList:[],
        dataForm: {
          userid: '',
          uniformsaSize: '',
          uniformsSize: '',
          uniformwSize: '',
          shoseSize: '',
          hatSize: ''
        },
        types: [],
        fileList:[],
        fileList2:[],
        currentPage: 1,
        total:0,
        uploadUrl:'',
        dataListSelections:[],
        dataRule: {
          name: [
            {required: true, message: '名称不能为空', trigger: 'blur'}
          ]
        }
      }
    },
    methods: {
      init (id) {
        if(!id) return
        this.visible = true
        this.$nextTick(() => {
          console.log('11111111111111111111')
          this.$refs['dataForm'].resetFields()
          this.dataForm.userid = id.userid
          this.dataForm.uniformsaSize = id.uniformsaSize
          this.dataForm.uniformsSize = id.uniformsSize
          this.dataForm.uniformwSize = id.uniformwSize
          this.dataForm.shoseSize = id.shoseSize
          this.dataForm.hatSize = id.hatSize
          this.useridList=[]
          this.equips=[]
          this.dataListSelections=[]
        })

      },


      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {

                this.$http({
                  url: '/bjba/yhgl/updateSize',
                  method: 'post',
                  data: this.dataForm
                }).then(({data}) => {
                  if (data && data.code === 200) {
                    this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 1500
                    })
                    this.visible = false
                    this.$emit('refreshDataList')
                  } else if(data && data.code === 500) {
                    this.$message({
                      message: data.message,
                      type: 'error',
                      duration: 1500
                    })
                  }
                })


          }
        })
      }
    }
  }
</script>
